import React from 'react';
import Route from 'react-router';

type Props = {
    children: React.ReactNode,
    router: Route,
};

export const Setup: React.FC<Props> = ({ children }: Props) => (
    <div className="h-full w-full flex flex-col lg:flex-row">
        {children}
    </div>
);

export default Setup;
